import React from 'react';
import { whatAnchorIs } from '../../data/mock';
import { Check } from 'lucide-react';

const WhatAnchorIs = () => {
  return (
    <section id="what-anchor-is" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-3xl">
          <h2 className="font-display text-3xl md:text-4xl font-normal text-[#1E2E2A] mb-8 tracking-wider">
            {whatAnchorIs.title}
          </h2>
          
          <p className="text-lg text-[#1E2E2A]/70 leading-relaxed mb-4">
            {whatAnchorIs.copy}
          </p>
          
          <p className="text-lg text-[#1E2E2A]/70 leading-relaxed mb-10">
            {whatAnchorIs.secondaryCopy}
          </p>

          <ul className="space-y-4">
            {whatAnchorIs.bullets.map((item, index) => (
              <li key={index} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 rounded-md bg-[#3E6259]/10 flex items-center justify-center mt-0.5">
                  <Check className="w-4 h-4 text-[#3E6259]" />
                </div>
                <span className="text-[#1E2E2A] text-lg">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhatAnchorIs;
